import './item-card.scss';

import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { Item, itemSelectors } from '@skinsoft/entity';
import { Component, Vue } from 'vue-property-decorator';

import { Touchable } from '../touchable';
import { Description } from './description';
import { Location } from './location';
import { Media } from './media';

@Component({
    components: {
        sDescription: Description,
        sLocation: Location,
        sMedia: Media,
        sTouchable: Touchable,
    },
    props: {
        focused: {
            required: false,
        },
        item: {
            required: true,
        },
        readonly: {
            default: false,
            required: false,
        },
    },

    template: require('./item-card.html'),
})
export class ItemCard extends Vue {
    public item: Item;
    public interactive: boolean;
    public focused: boolean;
    public readonly: boolean;

    public contentReady: boolean = false;
    public encounteredError: boolean = false;
    public validated: boolean = false;
    public loadingIcon = faCircleNotch;

    public itemSelectors = itemSelectors;

    private descriptionReady: boolean = false;
    private locationReady: boolean = false;

    public onDescriptionReady() {
        this.descriptionReady = true;
        this.processContentReady();
    }

    public onLocationReady() {
        this.locationReady = true;
        this.processContentReady();
    }

    public processContentReady() {
        this.contentReady = this.descriptionReady && this.locationReady;
    }
}
